import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["title", "iconUrl"];
import styled, { css, getSectionBackgroundStyle, mediaQuery } from 'academy-common-lib/utils/Styling';
import ACIllustration from 'academy-common-lib/components/illustration/ACIllustration';
import { H2 } from 'foundations-components/transitional/components/H2';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CertificationPreviewSection = styled.section.withConfig({
  displayName: "ACCertificatePreviewSection__CertificationPreviewSection",
  componentId: "sc-1i03obp-0"
})(["min-height:", ";color:", ";display:flex;align-items:center;", " ", " ", ""], ({
  theme
}) => theme.space['1700'], ({
  theme,
  $backgroundColor = 'text-inverse-default'
}) => theme.color[$backgroundColor], mediaQuery('mobile', css(["flex-direction:column;gap:", ";padding:", ";"], ({
  theme
}) => theme.space['800'], ({
  theme
}) => `${theme.space['600']} 0 ${theme.space['300']} 0`)), ({
  theme
}) => getSectionBackgroundStyle(theme.color['fill-accent-neutral-subtle']), ({
  $spaceCssStyles
}) => $spaceCssStyles);
const ACCertificatePreviewSection = _ref => {
  let {
      title,
      iconUrl
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps
  } = filterTokenProps(props);
  const spaceCssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsxs(CertificationPreviewSection, {
    $spaceCssStyles: spaceCssStyles,
    children: [/*#__PURE__*/_jsx(View, {
      as: "div",
      marginBlockEnd: "-400",
      marginBlockStart: "-300",
      children: /*#__PURE__*/_jsx(ACIllustration, {
        iconUrl: iconUrl,
        name: "certificate",
        title: title,
        width: 300
      })
    }), /*#__PURE__*/_jsxs(View, {
      as: "div",
      marginInlineStart: "600",
      children: [/*#__PURE__*/_jsx(H2, {
        marginBlockEnd: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyCommon.certificatePreview.title"
        })
      }), /*#__PURE__*/_jsxs(List, {
        marginBlockEnd: "0",
        paddingInlineStart: "800",
        styled: true,
        children: [/*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyCommon.certificatePreview.point1"
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyCommon.certificatePreview.point2"
          })
        })]
      })]
    })]
  });
};
export default ACCertificatePreviewSection;